module.exports = __webpack_public_path__ + "static/media/icon-user.149ab2fd.svg";